import { FocusOnce, ModalBody, ModalHeader } from "baseui/modal";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import CircleLoader from "components/atoms/CircleLoader";
import RemarksForm from "./RemarksForm";
import UpdateForm from "./RemarksForm/UpdateForm";
import PartnerService from "services/partner.service";

export default function PartnerRemarks() {
  const dispatch = useAppDispatch();
  const { id, index } = useAppSelector((state) => state.modal.data);
  const { loading } = useAppSelector((state) => state.partners);

  const handleSubmit = async (values: any) => {
    let payload = {
      remarks: values.remarks,
      id: id,
    };
    PartnerService.addRemarks(payload, dispatch);
  };
  return (
    <>
      <FocusOnce>
        <ModalHeader>Add Remarks</ModalHeader>
      </FocusOnce>
      <ModalBody>
        {loading && <CircleLoader />}
        <RemarksForm onSubmit={handleSubmit} />
        {id && <UpdateForm index={index} />}
      </ModalBody>
    </>
  );
}
